import * as React from "react";

import * as querystring from "querystring";

import debounce from "lodash.debounce";

import LoadableEventAddOrEditContainer from "../EventAddOrEdit/LoadableEventAddOrEditContainer";

import CalendarDataTestingContainer from "../CalendarDataTesting/CalendarDataTestingContainer";
import EventDetailsViewContainer from "../EventDetails/EventDetailsViewContainer";
import EventViewContainer from "../EventView/EventViewContainer";
import FooterSectionContainer from "../FooterSection/FooterSectionContainer";
import InlineStyleContainer from "../InlineStyle/InlineStyleContainer";
import MainToolbarContainer from "../MainToolbar/MainToolbarContainer";
import SearchToolbarContainer from "../SearchToolbar/SearchToolbarContainer";

import RecurrenceModalContainer from "../RecurrenceModal/RecurrenceModalContainer";
import SelectEventsModalContainer from "../SelectEventsModal/SelectEventsModalContainer";

import "../../../../../node_modules/font-awesome/scss/font-awesome.scss"; // Font-Awesome SASS CSS sheet.
import "../../../../../node_modules/toastr/build/toastr.min.css";
import "../../../common/styles/common.css";
import "../../../common/styles/presenceFramework.css";

import "../../styles/calendar.scss";
import "../../styles/calendarExtra.scss";

import { handleResizeJQuery } from "../../scripts/calendarJQueryScript";

import { setUpSubNavDropdowns } from "../../scripts/jqueryAccessibleSubnavDropdown";

import { MONTHLY_MOBILE_WIDTH } from "../../classes/const";

export interface ICalendar {
  displayedEventId: number;
  eventScreenMode: string;
  iCalStartDate: Date;
  portletInstanceId: number;
  width?: number;
  viewMode: string;
  onWidthChanged: (width: number) => any;
}

export default class Calendar extends React.Component<ICalendar, any> {

  public constructor(props, context) {
    super(props, context);

    this.state = {
      displayExtras: false,
    };

    this.onDisplayExtras = this.onDisplayExtras.bind(this);
  }

  public onDisplayExtras(e): void {
    e.preventDefault();
    const displayExtras = this.state.displayExtras;
    this.setState({ displayExtras: !displayExtras });
  }

  public componentDidMount() {
    setUpSubNavDropdowns();
    setTimeout(() => {
      window.addEventListener("resize", this.debouncedNotifyComponentThatWidthHasChanged); // Brief debounce to limit resize from firing more than once every half second.
    });
    this.debouncedNotifyComponentThatWidthHasChanged();
  }

  public componentDidUpdate() {
    this.debouncedNotifyComponentThatWidthHasChanged();
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedNotifyComponentThatWidthHasChanged);
  }

  public render() {
    const id = "portlet" + this.props.portletInstanceId;
    const displayedEventId = this.props.displayedEventId;

    const displayEventsList = this.props.eventScreenMode === "LIST" && displayedEventId === 0;
    const displayEventDetailsView = this.props.eventScreenMode === "VIEW" && displayedEventId !== 0;
    const displayEventDetailsAddOrEdit = this.props.eventScreenMode === "ADD" || this.props.eventScreenMode === "EDIT";

    const portletClassName = this.getPortletClassName(displayEventDetailsView, displayEventDetailsAddOrEdit);

    const displayStateData = this.getWhetherToDisplayStateData();

    return (
      <div>

        {/* <div>eventScreenMode: {this.props.eventScreenMode}; displayedEventId: {this.props.displayedEventId} </div>  */}

        <RecurrenceModalContainer />
        <SelectEventsModalContainer />

        <div id={id} className={portletClassName}>
          <InlineStyleContainer />
          <div className="PO-contentArea">
            <div className="CAL-wrapper">

              {displayEventsList &&
                <React.Fragment>
                  <SearchToolbarContainer />
                  <div className="CAL-box">
                    <MainToolbarContainer />
                    <EventViewContainer />
                    <FooterSectionContainer />
                  </div>
                </React.Fragment>
              }

              {displayEventDetailsView &&
                <EventDetailsViewContainer />
              }

              {displayEventDetailsAddOrEdit &&
                <LoadableEventAddOrEditContainer />
              }

              {displayStateData &&
                <CalendarDataTestingContainer />
              }

            </div>
          </div>

        </div>
      </div>
    );
  }

  private notifyComponentThatWidthHasChanged = () => {
    this.props.onWidthChanged(this.props.width); // Call action to update the width stored in the state - used elsewhere to swap Event View Mode for narrow screen.
    handleResizeJQuery(this.props.portletInstanceId);
  }

  // tslint:disable-next-line:member-ordering
  private debouncedNotifyComponentThatWidthHasChanged = debounce(this.notifyComponentThatWidthHasChanged, 250, { leading: false, trailing: true });

  private getPortletClassName = (displayEventDetails: boolean, displayEventAddOrEdit: boolean): string => {
    let portletClassName = "PO-wrapper PO-calendar";

    let addDailyListClass = false;
    let addWeeklyClass = false;
    let addMonthlyWideClass = false;
    let addMonthlyNarrowClass = false;
    let addMobileClass = false;

    if (this.props.viewMode === "DAILYLIST" || this.props.viewMode === "MONTHLYLIST") { addDailyListClass = true; }
    if (this.props.viewMode === "WEEKLY") { addWeeklyClass = true; }

    if (this.props.viewMode === "MONTHLY") {
      if (this.props.width <= MONTHLY_MOBILE_WIDTH) {
        addMobileClass = true;
        addMonthlyNarrowClass = true;
      } else {
        addMonthlyWideClass = true;
      }
    }

    if (addDailyListClass) { portletClassName += " CAL-V-LV"; }
    if (addWeeklyClass) { portletClassName += " CAL-V-WV"; }
    if (addMonthlyWideClass) { portletClassName += " CAL-V-MV"; }
    if (addMonthlyNarrowClass) { portletClassName += " CAL-V-MV-mob"; }

    if (addMobileClass) { portletClassName += " PO-mobileView"; }

    if (displayEventDetails === true) { portletClassName += " CAL-V-eventView"; }
    if (displayEventAddOrEdit === true) { portletClassName += " CAL-V-addEvent"; }

    return portletClassName;
  }

  private getWhetherToDisplayStateData = () => {

    // Display the state data if there is &showTime=true in querystring.
    let theLocation = location.search;
    if (theLocation && theLocation.length > 0 && theLocation[0] === "?") { theLocation = theLocation.substring(1, theLocation.length); }

    let displayStateData = false;
    const querystringObj = querystring.parse(theLocation);
    if (querystringObj && querystringObj.showTime) {
      if (querystringObj.showTime === "true") {
        displayStateData = true;
      }
    }
    return displayStateData;
  }
}
